module.exports = __webpack_public_path__ + "static/media/covidualizer.5006a434.png";